import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_app_form_item = _resolveComponent("app-form-item")!

  return (_openBlock(), _createBlock(_component_app_form_item, {
    label: _ctx.label,
    "control-class": _ctx.controlClass,
    "error-message": _ctx.errorMessage
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_date_picker, _mergeProps({
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        type: _ctx.type,
        placeholder: _ctx.label
      }, _ctx.$attrs, {
        "prefix-icon": null,
        format: _ctx.format
      }), _createSlots({ _: 2 }, [
        _renderList(_ctx.$slots, (_, name) => {
          return {
            name: name,
            fn: _withCtx((slotData) => [
              _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)))
            ])
          }
        })
      ]), 1040, ["modelValue", "type", "placeholder", "format"])
    ]),
    _: 3
  }, 8, ["label", "control-class", "error-message"]))
}